export const visit = (vm, at) => {
at({ "fr": { "conversations-message-history": { "responder": { "automatic": "Automatis\xE9", "bot": "Bot", "unknownResponder": "Utilisateur inconnu", "unknownSender": "Exp\xE9diteur inconnu", "unknownVisitor": "Visiteur inconnu", "unknownVisitorAvatar": "Visiteur inconnu" } } } });
};